export default [
  {
    path: '/ui/form',
    name: 'Form',
    meta: {
      title: 'TabTitle.form',
    },
    component: () => import('@/pages/UI/form.vue'),
  },
  {
    path: '/ui/value-confirmation',
    name: 'ui_ValueConfirmationExamples',
    meta: {
      title: 'TabTitle.form',
    },
    component: () => import('@/pages/UI/value-confirmation-examples.vue'),
  },
  {
    path: '/ui/ui-test',
    name: 'ui_test',
    component: () => import('@/pages/UI/ui-test.vue'),
  },
  {
    path: '/ui/table',
    name: 'ui_test_tables',
    component: () => import('@/pages/UI/table.vue'),
  },
];
